var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.configNameCat},[_c('p',{class:_vm.$style.configTitle},[_vm._v(" "+_vm._s(_vm.configurationTitle)+" ")]),(_vm.configurationCategories)?_c('p',{class:_vm.$style.configCategories},[_vm._v(" "+_vm._s(_vm.configurationCategories)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }